'use client';

import { Notification } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { LEAD_TEST_IDS } from '../constants';

export const LeadErrorNotification = () => {
    const { t } = useTranslations();

    return (
        <Notification
            headingTag="h3"
            heading={t['content.lead.error.title']}
            status="error"
            data-test={LEAD_TEST_IDS.ERROR_NOTIFICATION}
        >
            {t['content.lead.error.message']}
        </Notification>
    );
};
